import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ApplicationService } from '../../../services/application.service';
import { first } from 'rxjs';

@Component({
  selector: 'app-ping-pacs',
  templateUrl: './ping-pacs.component.html',
  styleUrls: ['./ping-pacs.component.scss']
})
export class PingPacsComponent implements OnInit {

  localPacsAvailable = false;

  constructor(private readonly applicationService: ApplicationService) { }

  ngOnInit(): void {
    this.ping();
    setInterval(() => {
      this.ping();
    }, environment.pingInterval);
  }

  private ping() {
    this.applicationService.ping()
      .pipe(first())
      .subscribe(result => {
        this.localPacsAvailable = result?.ok ?? false;
      });
  }
}
